import { Button } from 'react-bootstrap';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { retrievePrevSearch } from '../../actions/umoGallery';

const mapStateToProps = (state) => ({
  umoGallery: state.umoGallery,
});

const mapDispatchToProps = (dispatch) => ({
  retrievePrevSearch: (searchParams) =>
    dispatch(retrievePrevSearch(searchParams)),
});

function PrevSearchButton(props) {
  const prevSearch =
    props.umoGallery.get('prevSearches').size > 1
      ? props.umoGallery.get('prevSearches').last()
      : null;
  let prevSearchLabel = '';
  if (prevSearch && prevSearch.get('metadataList'))
    prevSearchLabel = props.intl.formatMessage({
      id: 'searchResults.previousSearchAdv',
    });
  else if (prevSearch && prevSearch.get('tagList') && prevSearch.get('tagList')[0])
    prevSearchLabel = prevSearch.get('tagList')[0].label;
  else prevSearchLabel = '';
  return (
    <div className="umo-gallery-header__previous">
      {prevSearch && prevSearchLabel ? (
        <Button
          variant="link"
          onClick={() => props.retrievePrevSearch(prevSearch)}
          className="font-sm-regular umo-gallery-header__link-button"
        >
          {props.intl.formatMessage({ id: 'searchResults.previousSearch' })}{' '}
          {prevSearchLabel}
        </Button>
      ) : (
        ''
      )}
    </div>
  );
}

PrevSearchButton.propTypes = {
  retrievePrevSearch: PropTypes.func,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(PrevSearchButton)
);
